import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AppContext from 'AppContext';

const BackToOverview = () => {
  const { t } = useTranslation('newsletter');
  const { overviewBaseUrl } = useContext(AppContext);

  return (
    <div className="backtooverview">
      <a
        href={overviewBaseUrl}
        className="button button--primary button--align-right backtooverview__button"
      >
        {t('back_to_overview_title')}
      </a>
    </div>
  );
};

export default BackToOverview;
